import store from '@/store'
import {
  connectionService,
  GEOCODING_REVERSE_URI,
  ACCOUNT_FETCH_URI
} from '@leapsight/styleguide'
import { GlobalHelpers } from '@/helpers/mainExports'
export default {
  PROMISE_STATUS: Object.freeze({
    rejected: 'rejected',
    fulfilled: 'fulfilled'
  }),
  splitArray(array, elementosPorSubArray) {
    const result = []

    for (let i = 0; i < array.length; i += elementosPorSubArray) {
      const subArray = array.slice(i, i + elementosPorSubArray)
      result.push(subArray)
    }

    return result
  },
  getWidthHeightByImg({ document, img, width }) {
    const imgProps = document.getImageProperties(img)
    const height = (imgProps.height * width) / imgProps.width
    return { width, height }
  },
  customTimer({ ms }) {
    return new Promise(resolve => {
      setTimeout(resolve, ms)
    })
  },
  chunkArray(arr, size) {
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    )
  },
  getAgentIconType(type) {
    const typeCondition = type.split(':')[2]
    let icon
    switch (typeCondition) {
      case 'speed_limit':
      case 'speed_limit_breached':
      case 'speed_limit_observed':
        icon = 'icon_car_speed'
        break
      case 'panic':
        icon = 'icon_panic_button'
        break
      case 'loading_gate':
        icon = 'icon_truck_loading_gate_open'
        break
      case 'unhook':
        icon = 'icon_unhook'
        break
      case 'tamper_detect':
        icon = 'icon_antivandalism'
        break
      case 'no_reporting':
        icon = 'icon_no_report'
        break
      case 'geofence_ingress':
        icon = 'icon_geofences_in'
        break
      case 'geofence_egress':
        icon = 'icon_geofences_out'
        break
      case 'contact':
      case 'contact_on':
        icon = 'icon_ignition_on'
        break
      case 'contact_off':
        icon = 'icon_ignition_off'
        break
      case 'geofence_ingress_breached':
      case 'geofence_ingress_observed':
      case 'geofence_egress_breached':
      case 'geofence_egress_observed':
        icon = 'icon_link'
        break
      case 'fuel_cut_off_false':
        icon = 'icon_fuel_cut_off_false'
        break
      case 'fuel_cut_off_true':
        icon = 'icon_fuel_cut_off_true'
        break
      case 'main_power_off':
        icon = 'icon_car_battery_off'
        break
      case 'main_power_on':
        icon = 'icon_car_battery'
        break
      case 'stopped':
        icon = 'icon_stop_large_lapse'
        break
      // eventos de seguridad debidos e indebidos
      // porton
      case 'cargo_gate_opening': // condicion mrn:agent_condition:cargo_gate_normal -> todos los eventos
      case 'unexpected_cargo_gate_opening': // condition mrn:agent_condition:cargo_gate -> indebido
        icon = 'icon_unexpected_cargo_gate_opening'
        break
      // puerta
      case 'door_opening': // condicion driver_door_normal -> todos los eventos
      case 'unexpected_door_opening': // condition mrn:agent_condition:driver_door -> indebidos
        icon = 'icon_unexpected_door_opening'
        break
      // semi
      case 'semi_detach': // condition mrn:agent_condition:semi_detach_normal -> todos los eventos
      case 'unexpected_semi_detach': // condition mrn:agent_condition:semi_detach -> indebidos
        icon = 'icon_unexpected_semi_detach'
        break
      case 'low_battery':
        icon = 'icon_cel_level_1'
        break
      case 'temperature_breached':
      case 'temperature':
      case 'temperature_observerd':
        icon = 'icon_temperature'
        break
      case 'ralenti':
      case 'ralenti_breached':
      case 'ralenti_observed':
        icon = 'icon_ralenti'
        break
      case 'fuel_deviation_breached':
      case 'fuel_deviation':
      case 'fuel_deviation_observed':
        icon = 'icon_fuel_deviation'
        break
      case 'dump_truck':
        icon = 'icon_dump_truck'
        break
      case 'jamming_detected':
      case 'jamming_ended':
      case 'jamming':
        icon = 'icon_jamming'
        break
      default:
        icon = 'icon_events'
        break
    }
    return icon
  },
  getBundleLocation(bundle) {
    return new Promise((resolve, reject) => {
      const args = bundle
      const connection = store.getters['authState/connection']
      const kwArgs = connectionService.createkwArgs()
      const options = {}

      connection.session
        .call(GEOCODING_REVERSE_URI, args, kwArgs, options)
        .then(
          res => {
            resolve(res)
          },
          wampError => {
            reject(wampError)
          }
        )
    })
  },
  getAccount() {
    return new Promise((resolve, reject) => {
      const connection = store.getters['authState/connection']
      const kwArgs = connectionService.createkwArgs()
      const accountId = connectionService.getAccountId()

      connection.session
        .call(ACCOUNT_FETCH_URI, [accountId], kwArgs, {})
        .then(data => {
          resolve(data.args[0])
        })
        .catch(wampError => {
          reject(wampError)
        })
    })
  },
  getConnection() {
    return store.getters['authState/connection']
  },
  parseWindow(window) {
    if (window > 0) {
      const days = Math.floor(window / (3600 * 24))
      const hours = Math.floor((window % (3600 * 24)) / 3600)
      const minutes = Math.floor((window % 3600) / 60)
      const seconds = Math.floor(window % 60)
      const dDisplay = days > 0 ? `${days} d ` : ''
      const hDisplay = hours > 0 ? `${hours} hs ` : ''
      const mDisplay = minutes > 0 ? `${minutes} min ` : ''
      const sDisplay = seconds > 0 ? `${seconds} seg ` : ''
      return dDisplay + hDisplay + mDisplay + sDisplay
    } else return 0
  },
  getTimeZoneName(countryId) {
    switch (countryId) {
      case 'ar':
        return 'America/Argentina/Buenos_Aires'
      case 'cl':
        return 'America/Santiago'
      case 'uy':
        return 'America/Montevideo'
      default:
        return 'America/Argentina/Buenos_Aires'
    }
  },
  formatHeaderDocument(workSheet, from, to, row, autofilter = false) {
    // Color background encabezado
    const rows = workSheet.getRow(row)
    for (
      let codeChar = from.codePointAt();
      codeChar <= to.codePointAt();
      codeChar++
    )
      rows.getCell(String.fromCharCode(codeChar)).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '1F2849' }
      }

    const font = {
      name: 'Calibri',
      family: 1,
      color: { theme: 2 },
      bold: true
    }

    for (
      let codeChar = from.codePointAt();
      codeChar <= to.codePointAt();
      codeChar++
    )
      rows.getCell(String.fromCharCode(codeChar)).font = font

    if (autofilter)
      workSheet.autoFilter = {
        from: from + 1,
        to: to + 1
      }
  },
  setHeaderBackgroud(showEvent, showTemperature, ws) {
    const servicesForAddColumn = [
      { 'mrn:service:telemetry': { slots: 2 } },
      { 'mrn:service:ibutton': { slots: 1 } }
    ]
    let columnAdd = 0
    servicesForAddColumn.forEach(el => {
      const service = Object.keys(el)[0]
      if (service in store.getters['trailState/getThing']?.services)
        columnAdd += el[service].slots
    })
    if (showEvent) {
      columnAdd++
    }
    if (showTemperature) {
      columnAdd++
    }
    const charAt = String.fromCharCode('J'.codePointAt() + columnAdd)
    GlobalHelpers.formatHeaderDocument(ws, 'A', charAt, 1, true)
  },
  fillDataSecondPage(ws, colum, row, data) {
    const alignmentStyle = { vertical: 'middle', horizontal: 'right' }

    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].length; j++) {
        ws.getCell(
          String.fromCharCode(colum.codePointAt() + j) + (i + row + 1)
        ).value = data[i][j]
        ws.getCell(
          String.fromCharCode(colum.codePointAt() + 1) + (i + row + 1)
        ).alignment = alignmentStyle
      }
    }
  },
  createBorderSquare(ws, from, to, fromRow, toRow) {
    for (
      let codeChar = from.codePointAt() + 1;
      codeChar < to.codePointAt();
      codeChar++
    ) {
      ws.getCell(String.fromCharCode(codeChar) + fromRow).border = {
        top: { style: 'thin' }
      }
    }

    for (let row = fromRow; row <= toRow; row++) {
      if (row == fromRow) {
        ws.getCell(from + row).border = {
          left: { style: 'thin' },
          top: { style: 'thin' }
        }
        ws.getCell(to + row).border = {
          right: { style: 'thin' },
          top: { style: 'thin' }
        }
      } else if (row == toRow) {
        ws.getCell(from + row).border = {
          left: { style: 'thin' },
          bottom: { style: 'thin' }
        }
        ws.getCell(to + row).border = {
          right: { style: 'thin' },
          bottom: { style: 'thin' }
        }
      } else {
        ws.getCell(from + row).border = {
          left: { style: 'thin' }
        }
        ws.getCell(to + row).border = {
          right: { style: 'thin' }
        }
      }
    }

    for (
      let codeChar = from.codePointAt() + 1;
      codeChar < to.codePointAt();
      codeChar++
    ) {
      ws.getCell(String.fromCharCode(codeChar) + toRow).border = {
        bottom: { style: 'thin' }
      }
    }
  }
}
